export default __webpack_public_path__ + "static/media/success-circle.96b04a3e.svg";